module.exports = __webpack_public_path__ + "img/feature_buy_bonus_th.a0203b5c.png";